import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-xl mt-10">
      <h1 className="text-3xl font-bold mb-4 text-gray-800">Privacy Policy</h1>

      <p className="text-gray-700 mb-4">
        This Privacy Policy describes how <strong>Gerado</strong> ("we", "us", or "our") collects, uses, and discloses your personal information when you visit or make a purchase from{" "}
        <a href="https://www.thegerado.com" className="text-blue-600 underline">
          www.thegerado.com
        </a>{" "}
        (the "Site").
      </p>
      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">1. How We Collect and Use Your Personal Information</h2>
      <ul className="list-disc list-inside text-gray-700 space-y-1">
        <li>Directly from you (e.g., contact details, account info, orders)</li>
        <li>Automatically via cookies (e.g., usage data, IP address, device info)</li>
        <li>From third parties (e.g., payment processors)</li>
      </ul>

      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">2. How We Use Your Information</h2>
      <ul className="list-disc list-inside text-gray-700 space-y-1">
        <li>To provide products and services</li>
        <li>For marketing and advertising</li>
        <li>For security and fraud prevention</li>
        <li>To communicate and provide support</li>
      </ul>

      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">3. Cookies</h2>
      <p className="text-gray-700 mb-4">
        We use cookies to improve your experience. You can manage your cookie preferences through your browser.
      </p>

      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">4. How We Disclose Personal Information</h2>
      <ul className="list-disc list-inside text-gray-700 space-y-1">
        <li>Vendors and service providers</li>
        <li>Business and marketing partners</li>
        <li>Affiliates and legal entities</li>
        <li>Legal obligations and business transfers</li>
      </ul>
      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">5. Third Party Websites</h2>
      <p className="text-gray-700 mb-4">
        We are not responsible for the privacy practices of third-party websites linked on our site.
      </p>

      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">6. Children's Data</h2>
      <p className="text-gray-700 mb-4">
        We do not knowingly collect data from children. If you believe your child has shared data with us, contact us to delete it.
      </p>

      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">7. Security and Retention</h2>
      <p className="text-gray-700 mb-4">
        We use reasonable security measures but cannot guarantee complete protection. Data retention depends on legal and operational needs.
      </p>

      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">8. Your Rights</h2>
      <ul className="list-disc list-inside text-gray-700 space-y-1">
        <li>Right to access, delete, or correct your information</li>
        <li>Right to opt-out of targeted advertising</li>
        <li>Right to restrict or withdraw consent</li>
      </ul>

      <p className="text-gray-700 mt-6">
        To exercise your rights, contact us at: <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:garadofashion@gmail.com" className="text-blue-600 underline">
          geradofashion@gmail.com
        </a>
        <br />
      </p>
    </div>
  );
};

export default PrivacyPolicy;
